module.exports = __webpack_public_path__ + "static/media/my-account-icon.a8355775.svg";